export default "__VITE_ASSET__BYkR9Vgn__"